import { axiosInstance } from '../../../common/axiosInstans';

export interface MessageListDto {
    id: string;
    title: string;
    createdByName: string;
    createdOn: string;
    readCount: number;
    totalUserCount: number;
}

export interface MessageDto {
    id: string;
    title: string;
    content: string;
    createdByName: string;
    createdOn: string;
    readCount: number;
    totalUserCount: number;
}

export interface CreateMessageRequest {
    title: string;
    content: string;
}

class MessagesService {
    getMessages = async (): Promise<MessageListDto[]> => {
        const response = await axiosInstance.get('/messages');
        return response.data;
    };

    getMessage = async (id: string): Promise<MessageDto> => {
        const response = await axiosInstance.get(`/messages/${id}`);
        return response.data;
    };

    createMessage = async (data: CreateMessageRequest): Promise<MessageDto> => {
        const response = await axiosInstance.post('/messages', data);
        return response.data;
    };

    deleteMessage = async (id: string): Promise<void> => {
        await axiosInstance.delete(`/messages/${id}`);
    };
}

export default MessagesService;
